/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ChangelogInputs */

const id_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan perubahan`)
};

const ms_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log perubahan`)
};

const da_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog`)
};

const de_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll`)
};

const en_us2_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_es2_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const es_mx2_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng mga Pagbabago`)
};

const fr_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal des modifications`)
};

const it_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche`)
};

const hu_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló`)
};

const nl_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek`)
};

const no_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg`)
};

const pl_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian`)
};

const pt_br2_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de alterações`)
};

const pt_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações`)
};

const ro_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări`)
};

const fi_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki`)
};

const sv_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg`)
};

const vi_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi`)
};

const tr_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü`)
};

const cs_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените`)
};

const ru_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений`)
};

const uk_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін`)
};

const ar_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات`)
};

const hi_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग`)
};

const th_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const ja_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴`)
};

const zh_cn2_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志`)
};

const zh_hant1_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日誌`)
};

const ko_footer_changelog = /** @type {(inputs: Footer_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Footer_ChangelogInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_changelog = /** @type {((inputs?: Footer_ChangelogInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ChangelogInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_changelog(inputs)
	if (locale === "ms") return ms_footer_changelog(inputs)
	if (locale === "da") return da_footer_changelog(inputs)
	if (locale === "de") return de_footer_changelog(inputs)
	if (locale === "en-US") return en_us2_footer_changelog(inputs)
	if (locale === "es-ES") return es_es2_footer_changelog(inputs)
	if (locale === "es-MX") return es_mx2_footer_changelog(inputs)
	if (locale === "fil") return fil_footer_changelog(inputs)
	if (locale === "fr") return fr_footer_changelog(inputs)
	if (locale === "it") return it_footer_changelog(inputs)
	if (locale === "hu") return hu_footer_changelog(inputs)
	if (locale === "nl") return nl_footer_changelog(inputs)
	if (locale === "no") return no_footer_changelog(inputs)
	if (locale === "pl") return pl_footer_changelog(inputs)
	if (locale === "pt-BR") return pt_br2_footer_changelog(inputs)
	if (locale === "pt") return pt_footer_changelog(inputs)
	if (locale === "ro") return ro_footer_changelog(inputs)
	if (locale === "fi") return fi_footer_changelog(inputs)
	if (locale === "sv") return sv_footer_changelog(inputs)
	if (locale === "vi") return vi_footer_changelog(inputs)
	if (locale === "tr") return tr_footer_changelog(inputs)
	if (locale === "cs") return cs_footer_changelog(inputs)
	if (locale === "bg") return bg_footer_changelog(inputs)
	if (locale === "ru") return ru_footer_changelog(inputs)
	if (locale === "uk") return uk_footer_changelog(inputs)
	if (locale === "ar") return ar_footer_changelog(inputs)
	if (locale === "hi") return hi_footer_changelog(inputs)
	if (locale === "th") return th_footer_changelog(inputs)
	if (locale === "ja") return ja_footer_changelog(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_changelog(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_changelog(inputs)
	return ko_footer_changelog(inputs)
});
export { footer_changelog as "footer.changelog" }